// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"391":"info","462":"legal","644":"account","883":"shop","945":"dashboard"}[chunkId] || chunkId) + "." + {"289":"8eecd1c0","391":"7a51b0ac","462":"2007b071","476":"08a7407a","602":"bf136b4b","644":"b1c073da","854":"f1ec0311","883":"8327c4ae","945":"47d9f883"}[chunkId] + ".chunk.js";
};